import styled from 'styled-components';

import { Carousel } from '@xing-com/carousel';
import { GridContainer } from '@xing-com/grid';
import { scale000, space4XL, space5XL, spaceL } from '@xing-com/tokens';

const StyledCarousel = styled(Carousel)`
  margin: ${scale000} -${spaceL} ${space4XL};
`;

const StyledGridContainer = styled(GridContainer)`
  margin-bottom: ${space5XL};
`;

export const Styled = {
  Carousel: StyledCarousel,
  GridContainer: StyledGridContainer,
};
